import type { EventStatus, RecurrenceUnit } from "./types";

/** i18n keys — resolve with t() at render time. */
export const EVENT_STATUS_LABEL_KEYS: Record<EventStatus, string> = {
  DRAFT: "events.statusDraft",
  UPCOMING: "events.statusUpcoming",
  ACTIVE: "events.statusActive",
  COMPLETED: "events.statusCompleted",
  CANCELLED: "events.statusCancelled",
};

export const EVENT_STATUS_COLORS: Record<EventStatus, string> = {
  DRAFT: "bg-muted text-muted-foreground",
  UPCOMING: "bg-warning/10 text-warning",
  ACTIVE: "bg-success/10 text-success",
  COMPLETED: "bg-secondary/10 text-secondary",
  CANCELLED: "bg-destructive/10 text-destructive",
};

export const RECURRENCE_UNITS: RecurrenceUnit[] = ["DAYS", "WEEKS", "MONTHS"];

export const RECURRENCE_UNIT_LABEL_KEYS: Record<RecurrenceUnit, string> = {
  DAYS: "shared.recurrenceUnit.DAYS",
  WEEKS: "shared.recurrenceUnit.WEEKS",
  MONTHS: "shared.recurrenceUnit.MONTHS",
};
